<template>
  <div>
    <!-- On mobile, the filter is hidden in a drawer and this button shown instead -->
    <button type="button" class="button button--filter js-facetingform-toggler mb-1" data-containerid="eventsFacetingForm">Filter</button>

    <div class="modul-facetingform js-facetingform" id="eventsFacetingForm">
      <div class="facetingform__container">
        <div class="container__head">
          <h2 class="title">Filter</h2>
        </div>

        <div class="container__body">
          <form id="filterSection" class="facets" @submit.prevent="submitFilter">

            <fieldset class="facet">
              <div class="facet__body">
                <div class="form-group">
                  <label for="filter-term" class="form-label ">Suchbegriff</label>
                  <input class="form-control" v-model="filterValues.term" type="text" name="filter-term" id="filter-term">
                </div>

                <div class="form-group">
                  <label class="form-label" for="filter-date">Datum</label>
                  <!-- Class "datepicker" initializes a Flatpickr instance -->
                  <input type="text" class="form-control datepicker" id="filter-date" :min="today"
                         v-model="filterValues.dateString">
                </div>

              </div>
            </fieldset>

            <fieldset class="facet" v-for="(filterName, filterType) in filterTypes">
              <legend class="facet__head">
                <div class="facet-title" :data-collapsible-trigger="filterExpanded[filterType] ? 'opened' : ''" tabindex="0" role="button" :aria-controls="`filter-${filterType}`">
                  <span class="text">{{ filterName }}</span>
                </div>
              </legend>

              <div class="facet__body" :id="`filter-${filterType}`">
                <div class="form-check" v-for="option in filterOptions[filterType]">
                  <label class="form-check-label" :class="`filter-checkbox--${filterType}`">
                    <input type="checkbox"
                           class="form-check-input"
                           v-model="filterValues[filterType]"
                           :value="option.id"
                           :name="`${filterType}${option.id}`">

                    {{ option.name }}
                  </label>
                </div>
              </div>
            </fieldset>

            <div class="form-actions">
              <div class="form-actions__left">
                <button type="reset" v-if="anyFiltersSet" class="link reset" @click="$emit('reset-filter')">
                  zurücksetzen
                </button>
              </div>

              <div class="form-actions__right">
                <button class="button button--light">
                  Jetzt filtern
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterOptions: {
      type: Object
    },
    anyFiltersSet: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      filterTypes: {
        'audience': 'Zielgruppe',
        'district': 'Stadtbezirk',
        'category': 'Bewegungsart',
        // 'weekday': 'Wochentage',
        'eventType': 'Bewegungswelt',
        'accessibility': 'Barrierefreiheit'
      },
      filterExpanded: {
        'audience': true,
      },
      filterValues: {
        term: '',
        dateString: '',
        category: [],
        weekday: [],
        district: [],
        eventType: [],
        audience: [],
        accessibility: []
      },
      today: new Date().toISOString().split('T')[0],
    }
  },
  methods: {
    setCurrentFilter(filter) {
      this.filterValues = filter
      this.$emit('set-filter', this.filterValues)
    },
    submitFilter() {
      this.$emit('set-filter', this.filterValues)
      document.querySelector('#eventsFacetingForm .close')?.click();
    }
  },
  mounted() {
    this.$nextTick(() => {
      // Tell berlin_shop.js to process the filter form (datepicker, accordion)
      document.BO_initVerticalJs?.(true)
    })
  }
}
</script>
